import { memo } from "react";
import { IIconsProps } from "./icons.model";

const AtencaoIcon = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-triangle-exclamation' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(AtencaoIcon);
